export const calcCircularProgressRotation = (progress) => {
  const initialAngle = 0;
  const endAngle = 360;
  return initialAngle + endAngle * (progress / 100);
};